import AbstractOverlay from './AbstractOverlay';
const config = {
    splitList: [],
    symbolSize: 10,
    scale: 6.5, //圆圈动画
    brushType: "stroke", //stroke fill
    color: "#ff0000", //圆点颜色
    label: true,
    shadowBlur: 10,
    labelColor: "#ff0000",
    zlevel: 1,
    tooltip: {
        show: true,
        formatter: function (params) {
            return params.name + ":" + params.value[2] + "%";
        }
    }
}

export default class EffectScatter extends AbstractOverlay {
    constructor(opts) {
        super(config, opts);
    }
    toString() {
        return this.data.map((element) => {
            let style = this._getSplitListStyle(element);
            return {
                "type": "effectScatter",
                "coordinateSystem": "bmap",
                "rippleEffect": {
                    "scale": style.scale,
                    "brushType": style.brushType,
                    period: 6
                },
                hoverAnimation: true,
                // animation:false,
                symbolSize: style.symbolSize,
                "label": {
                    "normal": {
                        "show": style.label,
                        "position": "right",
                        "formatter": "{b}",
                        "color": style.labelColor,

                    }
                },

                "showEffectOn": "render",
                "itemStyle": {
                    "normal": {
                        "color": style.color,
                        shadowBlur: style.shadowBlur,
                        shadowColor: style.color,
                        borderWidth: 0,
                    }
                },
                emphasis: {
                    itemStyle: {
                        borderColor: style.color,
                        borderWidth: style.symbolSize
                    }
                },
                tooltip: this.options.tooltip,
                "data": [this._geoPointToEchart(element)],
                zlevel: style.zlevel
            }
        });

    }
}